(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("EventCarousel", [
            'jquery',
            'jqueryTD',
            'owlCarousel'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery'),
            require('jqueryTD'),
            require('owlCarousel')
        );
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(
            root.jquery,
            root.jqueryTD,
            root.owlCarousel
        );
    }
}(typeof self !== 'undefined' ? self : this, function ($, jqueryTD, owlCarousel) {

    // Define debounce function in jQuery
    $.debounce = jqueryTD.Cowboy.debounce;

    var screenWidth, newsContainerSelector, startInitPoint;

    function destroy () {
        $(newsContainerSelector).trigger("destroy.owl.carousel");
        $(newsContainerSelector).removeClass("owl-carousel");
    }

    function setNavHeight () {
        let itemHeight = $(newsContainerSelector).find('.new-card')[0].offsetHeight;

        $(newsContainerSelector).find('.owl-nav').find('.owl-next').css('height', itemHeight);
    }

    function init () {
        screenWidth = screen.width;

        if ( screenWidth >= startInitPoint && window.innerHeight >= 500 && !$(newsContainerSelector).hasClass("owl-carousel") ) {
            window.newsCaro = {
                carousel: $(newsContainerSelector).owlCarousel({
                    nav: true,
                    loop: true,
                    dots: false,
                    navText: ['<i class="icon icon-arrow-right-xl"></i>','<i class="icon icon-arrow-right-xl"></i>'],
                    responsive: {
                        768: {
                            items: 2,
                            autoWidth: true,
                            nav: false
                        },
                        1024: {
                            margin: 30,
                            items: 1
                        },
                        1200: {
                            items: 2,
                            margin: 30,
                            nav: true
                        },
                        1400: {
                            margin: 30,
                            nav: true,
                            autoWidth: false
                        },
                        1600: {
                            items: 3,
                            nav: true,
                            margin: 30,
                            autoWidth: false
                        },
                        1800: {
                            items: 4,
                            nav: true,
                            margin: 30,
                            autoWidth: false
                        }
                    },
                    onInitialized: function (event) {
                        this.$element.addClass("owl-carousel");

                        //$(window).trigger("resize");

                        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                          var evt = document.createEvent('UIEvents');
                          evt.initUIEvent('resize', true, false, window, 0);
                          window.dispatchEvent(evt);
                         } else {
                            window.dispatchEvent(new Event('resize'));
                         }

                        setNavHeight();
                    },
                    onResized: function () {
                        setNavHeight();
                    },
                    onChanged: function () {
                        setNavHeight();
                    }
                }),
                setNavHeight: setNavHeight
            };
        } else if ( screenWidth < startInitPoint && window.innerHeight < 500 && $(newsContainerSelector).hasClass("owl-carousel") ) {
            destroy();
        }
    }

    $(window).on('resize', $.debounce(500, init));

    return function (options) {
        screenWidth = screen.width;
        newsContainerSelector = options.containerSelector;
        startInitPoint = options.startInitPoint;

        init();
    };

}));



//////////////////
// WEBPACK FOOTER
// ./js/modules/newsCarousel/index.js
// module id = 20
// module chunks = 0